import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_WS_URL: z.string().min(1),
  VITE_APP_NAME: z.string().default('AIDU Vendor Admin'),
  VITE_MOCK: z
    .union([z.literal('true'), z.literal('false')])
    .optional()
    .default('false'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment configuration. Check .env file against .env.example.');
}

export const env = {
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  wsUrl: parsed.data.VITE_WS_URL,
  appName: parsed.data.VITE_APP_NAME,
  mock: parsed.data.VITE_MOCK === 'true',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
